import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function Delivery({ ...props }) {
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("delivery.label")}</p>
        </div>
        <div className="ContainerHorizontal MarginHorizontal">
          <Button
            onClick={() => {
              props.handleChange("delivery", true);
              props.handleNext();
            }}
            className={
              props.order.delivery === true
                ? "OldLace XL MarginHorizontal"
                : "TransparentWhite XL MarginHorizontal"
            }
          >
            {i18n.t("general.yes")}
          </Button>
          <Button
            onClick={() => {
              props.handleChange("delivery", false);
              props.handleNext();
            }}
            className={
              props.order.delivery === false
                ? "OldLace XL MarginHorizontal"
                : "TransparentWhite XL MarginHorizontal"
            }
          >
            {i18n.t("general.no")}
          </Button>
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => {
            if (!props.order.pickup && props.order.origin === "") {
              props.handleBack();
            } else if (props.order.pickup) {
              props.handleBack();
            } else {
              props.handleBack(2);
            }
          }}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
      </div>
    </>
  );
}

export default withTranslation()(Delivery);
